<template>
  <b-container>
    <div>
      <div>
        <div class="row no-gutters ">
          <div id="col-left-with-text" class="col-sm-12 col-md-12 col-lg-12">
            <div class="container-image">
              <img class="logo-img" :src="require(`@/assets/images/b122/logo.png`)" alt="Logo Login">
            </div>
            <div class="p-5 dark-theme card-public justify-content-center">
              <redirect-login-sign-up
                v-if="showRedirectLoginSignUpComponent"
                @showLoginView="showLoginView"
                @showSignUpView="showSignUpView"
                @showRedirectProModal="showRedirectProModal"
              />
              <login-component
                v-if="showLoginComponent"
                :username="username"
                @showValideAccount="showValidateAccountView"
                @showForgotPasswordView="showForgotPasswordView"
                @showSignUpView="showSignUpView"
                @showSmsCodeView="showSmsCodeView"
                @showRedirectProModal="showRedirectProModal"/>

              <sign-up-component
                v-if="showSignUpComponent"
                :username="username"
                @showLoginView="showLoginView"
                @showValideAccount="showValidateAccountView"
                @showSignUpView="showSignUpView"
              />

              <sms-code-component
                v-if="showSmsCodeComponent"
                ref="smsCodeComponent"
                @showLoginView="showLoginView"/>

              <validate-account-component
                :usernameProps="username"
                :passwordProps="password"
                v-if="showValidateAccountComponent"
                @showLoginView="showLoginView"/>

              <forgot-password-component
                v-if="showForgotPasswordComponent"
                @showLoginView="showLoginView"/>

              <reset-password-component
                v-if="showResetPasswordComponent"
                @showLoginView="showLoginView"/>

            </div>
          </div>
        </div>

      </div>
    </div>

    <redirect-connexion-modal ref="redirectConnexionModal" :username="username" :redirectConnexionUrl="redirectConnexionUrl"></redirect-connexion-modal>

  </b-container>
</template>

<script>

import i18n from '../../i18n'
import LoginComponent from './components/LoginComponent'
import ForgotPasswordComponent from './components/ForgotPasswordComponent'
import ValidateAccountComponent from './components/ValidateAccountComponent'
import SmsCodeComponent from './components/SmsCodeComponent'
import ResetPasswordComponent from './components/ResetPasswordComponent'
import RedirectLoginSignUp from "./components/RedirectLoginSignUp";
import SignUpComponent from "./components/SignUpComponent";
import RedirectConnexionModal from "./RedirectConnexionModal"
import api from '../../services/api'

export default {

  name: 'Login',

  components: {
    RedirectLoginSignUp,
    ResetPasswordComponent,
    SmsCodeComponent,
    ValidateAccountComponent,
    ForgotPasswordComponent,
    LoginComponent,
    i18n,
    SignUpComponent,
    RedirectConnexionModal,
  },

  data () {
    return {
      currentComponent: this.$route.params.component,
      username:null,
      password:null,
      redirectConnexionUrl:"",
    }
  },

  watch: {
    currentComponent(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.scrollToTop();
      }
    }
  },

  computed: {
    showRedirectLoginSignUpComponent(){
      return this.currentComponent  ? this.currentComponent === 'redirectLoginSignUp' : true
    },
    showLoginComponent () {
      return this.currentComponent === 'login'
    },

    showSignUpComponent () {
      return this.currentComponent === 'signUp'
    },
    showSmsCodeComponent () {
      return this.currentComponent === 'smsCode'
    },
    showValidateAccountComponent () {
      return this.currentComponent === 'validateAccount'
    },
    showForgotPasswordComponent () {
      return this.currentComponent === 'forgotPassword'
    },
    showResetPasswordComponent () {
      return this.currentComponent === 'resetPassword'
    }
  },

  mounted () {
    this.fetchRedirectConnexionUrl()

    if (localStorage.locale != null) {
      this.$i18n.locale = localStorage.locale
    }
    this.setVHVariable();
    window.addEventListener('resize', this.setVHVariable);

  },


  beforeDestroy() {
    window.removeEventListener('resize', this.setVHVariable);
  },


  methods: {

    async fetchRedirectConnexionUrl() {
      const response = await api.get('/home/getEnvironmentLinks')
      this.redirectConnexionUrl = response.data.proUrlLink
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },

    setVHVariable() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    },

    showLoginView (username) {
      this.username = username
      this.currentComponent = 'login'
    },
    showSignUpView (username) {
      this.username = username
      this.currentComponent = 'signUp'
    },
    showSmsCodeView (username, password, phoneNumber) {
      this.currentComponent = 'smsCode'
      this.$refs.smsCodeComponent.username = username
      this.$refs.smsCodeComponent.password = password
      this.$refs.smsCodeComponent.phoneNumber = phoneNumber
    },
    showValidateAccountView (username,password) {
      this.currentComponent = 'validateAccount'
      this.username = username
      this.password = password
    },
    showForgotPasswordView () {
      this.currentComponent = "forgotPassword"
      this.$router.push('/login/forgotPassword')
    },
    showResetPasswordView () {
      this.currentComponent = 'resetPassword'
    },

    showRedirectProModal (username) {
      this.username = username
      this.$bvModal.show('redirect-connexion-modal')
    },

  }

}

</script>

<style scoped>

b-container {
  padding: 0;
}

.container {
  padding: 0;
}

#col-left-with-text {
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content:flex-start;
  align-items: center;
  gap:1rem;
}

.container-image {
  z-index: 1;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 1rem;
}

.logo-img {
  margin-left: 10%;
  max-height: 60%;
  width: auto;
}


.card-public {
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 20px;
  width: 33%;
  border-radius: 30px;
  padding: 2.5rem !important;
}

@media (min-width: 600px) {
  .card-public {
    min-width: 550px;
  }
}

@media (min-height: 650px) and (min-width: 992px) {
  .card-public {
    margin-top: -100px;
    margin-bottom: 0px;
  }
}
@media (min-height: 1000px) and (min-width: 992px) {
  .card-public {
    margin-top: 0px;
    margin-bottom: 20px;
  }
}


@media (max-width: 991px) {
  #col-left-with-text {
    padding: 0;
    justify-content: flex-start;
    height: 100vh ;
  }

  .container-image {
    justify-content: center;
    height: auto;
    width:auto;
    flex-grow: 1;
  }

  .card-public {
    margin-top: auto;
    border-radius: 30px 30px 0 0;
    margin-bottom: 0;
    width: 100%;
  }

  .logo-img{
    margin-left: 0;
    height: auto;
    width: auto;
    object-fit: scale-down;
  }

}


@media (max-width: 767px) {

}

h1 {
  font-size: var(--title-level-one-font-size);
}
h2 {
  font-size: var(--title-level-two-font-size);
}

a {
  color: var(--main-yellow-medium);
}

</style>



// WEBPACK FOOTER //
// src/views/auth/Login.vue